import axios from 'axios';

const url = 'https://yadein-app.herokuapp.com/posts';

export const fetchPosts = () => axios.get(url);
export const createPost = (newPost) => axios.post(url, newPost);
export const likePost = (id) => axios.patch(`${url}/${id}/likePost`);
export const updatePost = (id, updatedPost) => axios.patch(`${url}/${id}`, updatedPost);//api call for update post route
export const deletePost = (id) => axios.delete(`${url}/${id}`);

